/**
 * Modal Block JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    // Initialize modals with custom options
    const modalElements = document.querySelectorAll('.modal');
    
    modalElements.forEach(modal => {
        const modalBlock = modal.closest('.modal-block');
        
        if (!modalBlock) return;
        
        // Get options from data attributes
        const animation = modalBlock.dataset.animation || 'fade';
        const backdrop = modalBlock.dataset.backdrop === 'true';
        const keyboard = modalBlock.dataset.keyboard === 'true';
        const autoOpen = modalBlock.dataset.autoOpen === 'true';
        const autoOpenDelay = parseInt(modalBlock.dataset.autoOpenDelay) || 0;
        const scrollTrigger = modalBlock.dataset.scrollTrigger === 'true';
        const scrollPercentage = parseInt(modalBlock.dataset.scrollPercentage) || 50;
        const showTriggerButton = modalBlock.dataset.showTriggerButton !== 'false';
        
        // Hide trigger button if auto-open mode
        if (autoOpen && !showTriggerButton) {
            const triggerButton = modalBlock.querySelector('.modal-trigger');
            if (triggerButton) {
                triggerButton.style.display = 'none';
            }
        }
        
        // Initialize Bootstrap modal with custom options
        let bsModal;
        
        try {
            // Check if Bootstrap is available
            if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                bsModal = new bootstrap.Modal(modal, {
                    backdrop: backdrop,
                    keyboard: keyboard,
                    focus: true
                });
            } else {
                console.warn('Bootstrap Modal not available, using fallback');
                initFallbackModal(modal, modalBlock);
                return;
            }
        } catch (error) {
            console.warn('Bootstrap Modal initialization failed, using fallback:', error);
            initFallbackModal(modal, modalBlock);
            return;
        }
        
        // Add custom animation class
        modal.classList.add(`modal-${animation}`);
        
        // Custom event handlers
        modal.addEventListener('show.bs.modal', function(event) {
            // Add any custom show logic here
            console.log('Modal opening:', modal.id);
        });
        
        modal.addEventListener('shown.bs.modal', function(event) {
            // Focus management for accessibility
            const firstFocusableElement = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            if (firstFocusableElement) {
                firstFocusableElement.focus();
            }
        });
        
        modal.addEventListener('hide.bs.modal', function(event) {
            // Add any custom hide logic here
            console.log('Modal closing:', modal.id);
        });
        
        modal.addEventListener('hidden.bs.modal', function(event) {
            // Return focus to trigger button
            const trigger = document.querySelector(`[data-bs-target="#${modal.id}"]`);
            if (trigger) {
                trigger.focus();
            }
        });
        
        // Auto-open functionality
        if (autoOpen) {
            if (autoOpenDelay > 0) {
                setTimeout(() => {
                    bsModal.show();
                }, autoOpenDelay * 1000);
            } else {
                bsModal.show();
            }
        }
        
        // Scroll trigger functionality
        if (scrollTrigger) {
            let hasTriggered = false;
            
            const scrollHandler = function() {
                if (hasTriggered) return;
                
                const scrollPosition = window.scrollY;
                const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
                const scrollPercent = (scrollPosition / documentHeight) * 100;
                
                if (scrollPercent >= scrollPercentage) {
                    hasTriggered = true;
                    bsModal.show();
                    window.removeEventListener('scroll', scrollHandler);
                }
            };
            
            window.addEventListener('scroll', scrollHandler);
        }
    });
    
    // Handle modal trigger buttons
    const modalTriggers = document.querySelectorAll('.modal-trigger');
    
    modalTriggers.forEach(trigger => {
        trigger.addEventListener('click', function(event) {
            // Add loading state if needed
            const originalText = trigger.textContent;
            
            // Optional: Add loading state
            // trigger.textContent = 'Loading...';
            // trigger.disabled = true;
            
            // Reset after modal opens
            setTimeout(() => {
                trigger.textContent = originalText;
                trigger.disabled = false;
            }, 100);
        });
    });
    
    // Keyboard navigation improvements
    document.addEventListener('keydown', function(event) {
        const openModal = document.querySelector('.modal.show');
        
        if (!openModal) return;
        
        // Enhanced escape key handling
        if (event.key === 'Escape') {
            const modalBlock = openModal.closest('.modal-block');
            const keyboardClose = modalBlock ? modalBlock.dataset.keyboard === 'true' : true;
            
            if (keyboardClose) {
                const bsModal = bootstrap.Modal.getInstance(openModal);
                if (bsModal) {
                    bsModal.hide();
                }
            }
        }
        
        // Tab trapping within modal
        if (event.key === 'Tab') {
            const focusableElements = openModal.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            
            if (focusableElements.length === 0) return;
            
            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            
            if (event.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
            } else {
                // Tab
                if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        }
    });
    
    // Auto-open modals (if needed for specific use cases)
    const autoOpenModals = document.querySelectorAll('[data-auto-open="true"]');
    
    autoOpenModals.forEach(modal => {
        const delay = parseInt(modal.dataset.autoOpenDelay) || 0;
        
        setTimeout(() => {
            const bsModal = new bootstrap.Modal(modal);
            bsModal.show();
        }, delay);
    });
    
    // Modal analytics tracking (optional)
    modalElements.forEach(modal => {
        modal.addEventListener('shown.bs.modal', function() {
            // Track modal opens
            if (typeof gtag !== 'undefined') {
                gtag('event', 'modal_open', {
                    modal_id: modal.id,
                    modal_title: modal.querySelector('.modal-title')?.textContent || 'Untitled Modal'
                });
            }
        });
    });
});

// Fallback modal implementation for when Bootstrap is not available
function initFallbackModal(modal, modalBlock) {
    const triggerButton = modalBlock.querySelector('.modal-trigger');
    const backdrop = modalBlock.dataset.backdrop === 'true';
    const keyboard = modalBlock.dataset.keyboard === 'true';
    
    // Create fallback modal functionality
    function showModal() {
        modal.style.display = 'block';
        modal.classList.add('show');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('modal-open');
        
        // Create backdrop
        if (backdrop) {
            const backdropElement = document.createElement('div');
            backdropElement.className = 'modal-backdrop fade show';
            document.body.appendChild(backdropElement);
            
            backdropElement.addEventListener('click', hideModal);
        }
        
        // Focus management
        const firstFocusable = modal.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) {
            firstFocusable.focus();
        }
    }
    
    function hideModal() {
        modal.style.display = 'none';
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        
        // Remove backdrop
        const backdropElement = document.querySelector('.modal-backdrop');
        if (backdropElement) {
            backdropElement.remove();
        }
        
        // Return focus
        if (triggerButton) {
            triggerButton.focus();
        }
    }
    
    // Event listeners
    if (triggerButton) {
        triggerButton.addEventListener('click', function(e) {
            e.preventDefault();
            showModal();
        });
    }
    
    // Close button
    const closeButtons = modal.querySelectorAll('[data-bs-dismiss="modal"], .modal-close');
    closeButtons.forEach(button => {
        button.addEventListener('click', hideModal);
    });
    
    // Keyboard support
    if (keyboard) {
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && modal.classList.contains('show')) {
                hideModal();
            }
        });
    }
    
    return {
        show: showModal,
        hide: hideModal
    };
}